export default __webpack_public_path__ + "static/media/projectCoinIcon.e4535e0a.svg";